import { todayBusinessDate } from '@nudool/shared';
import * as React from 'react';

import { Calendar, CalendarDayButton } from './components/ui/calendar.js';
import { ymdToLocalNoon } from './lib/ymd-date.js';

/** "Today" is the Pacific business day, the day pickers default to; a caller's `today` wins. */
export function DimeCalendar({ ...props }: Readonly<React.ComponentProps<typeof Calendar>>) {
  return <Calendar today={ymdToLocalNoon(todayBusinessDate())} {...props} />;
}

export function DimeCalendarDayButton({
  ...props
}: Readonly<React.ComponentProps<typeof CalendarDayButton>>) {
  return <CalendarDayButton {...props} />;
}
